import { type ReactNode } from 'react'
import { Button } from '../../../components/Button/Button'
import { ReactComponent as ZocksIcon } from '../../../assets/ZocksIcon.svg'
import { useNavigate } from 'react-router-dom'

type BackTarget = 'integration' | 'app'

type IntegrationManagementHeaderProps = {
  backTarget: BackTarget
  backPathOverride?: string
  title?: ReactNode
  actions?: ReactNode
}

export const IntegrationManagementHeader = ({ backTarget, backPathOverride, title, actions }: IntegrationManagementHeaderProps) => {
  const navigate = useNavigate()

  const handleBackButtonClicked = () => {
    if (backPathOverride) {
      navigate({ pathname: backPathOverride })
      return
    }

    const pathMap: Record<BackTarget, string> = {
      integration: '/account/integration-settings/integrations',
      app: '/account/integration-settings/oauth2apps',
    }

    navigate({
      pathname: pathMap[backTarget],
    })
  }

  return (
    <div className='d-flex flex-column'>
      <div className='d-flex zocks-pl-2.0 align-items-center gap-2'>
        <div className='d-flex align-items-center zocks-gap-2'>
          <div className='d-lg-none'>
            <ZocksIcon />
          </div>
          <div className='d-none align-items-center d-sm-flex zocks-gap-1.25'>
            <Button variant='link' className='back-button' onClick={handleBackButtonClicked}>
              <i className='bi bi-chevron-left' />
            </Button>
          </div>
        </div>
        {title ? <div className='d-flex align-items-center zocks-gap-1'>{title}</div> : null}
        {actions ? <div className='d-flex align-items-center zocks-gap-1 ms-auto me-2'>{actions}</div> : null}
      </div>
    </div>
  )
}
